import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { CommonModule } from '@angular/common';
import { FileConversionService } from '../services/file-conversion.service';

@Component({
  selector: 'app-progress-page',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, CommonModule],
  templateUrl: './progress-page.component.html',
  styleUrl: './progress-page.component.scss'
})
export class ProgressPageComponent implements OnInit, OnDestroy {
  progress = 0;
  isCompleted = false;
  isRedirecting = false;
  filename = 'test.pdf';
  size = 100;
  creationDate = '2021-01-01';
  
  private interval: any;
  private readonly totalDuration: number;
  private readonly updateInterval = 50; // Mise à jour toutes les 50ms pour une animation fluide

  constructor(
    private router: Router,
    private fileConversionService: FileConversionService,
    private meta: Meta,
    private title: Title
  ) {
    // Générer une durée totale aléatoire entre 7 et 12 secondes
    this.totalDuration = Math.floor(Math.random() * 6) + 7; // 7 à 12 secondes
  }

  ngOnInit() {
    // Définir le titre de la page (43 caractères - optimal)
    this.title.setTitle('Conversion en cours – pdf-to-word.fr');
    
    // Définir les meta tags SEO (160 caractères - optimal)
    this.meta.updateTag({ name: 'description', content: 'Votre fichier PDF est en cours de conversion en Word. Veuillez patienter pendant le traitement. Le processus est rapide et sécurisé.' });
    this.meta.updateTag({ name: 'keywords', content: 'conversion PDF en cours, traitement fichier PDF Word, conversion en ligne PDF, traitement document PDF' });
    
    // Meta tags supplémentaires pour le SEO
    this.meta.updateTag({ property: 'og:title', content: 'Conversion en cours – pdf-to-word.fr' });
    this.meta.updateTag({ property: 'og:description', content: 'Votre fichier PDF est en cours de conversion en Word. Veuillez patienter pendant le traitement. Le processus est rapide et sécurisé.' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });

    // Récupérer les données depuis le service
    const conversionData = this.fileConversionService.getConversionData();
    if (conversionData) {
      this.filename = conversionData.filename;
      this.size = conversionData.size || 100;
    }

    this.startProgress();
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  private startProgress() {
    const startTime = Date.now();
    
    this.interval = setInterval(() => {
      const currentTime = Date.now();
      const elapsed = currentTime - startTime;
      const totalTime = this.totalDuration * 1000;
      
      if (elapsed >= totalTime) {
        this.progress = 100;
        this.isCompleted = true;
        clearInterval(this.interval);
        
        // Simuler la redirection après 2 secondes
        setTimeout(() => {
          this.isRedirecting = true;
          this.router.navigate(['/email-page']);
        }, 2000);
      } else {
        // Calculer le pourcentage basé sur le temps écoulé
        this.progress = Math.round((elapsed / totalTime) * 100);
      }
    }, this.updateInterval);
  }
}
